var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('h2',[_vm._v("Invoices")]),_c('invoice-list',{attrs:{"invoices":_vm.invoices},on:{"remove":_vm.remove,"view":_vm.view}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }